import React, {useState, useEffect, useRef, useLayoutEffect} from "react";
import AmChartRingIndicator from "../../../components/AmChartRingIndicator";
import BulletCharts from "./activityinsights/BulletCharts";
import TopOffenders from "./activityinsights/TopOffenders";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { LICENCE_KEY } from "../../../constants/charts";

am4core.addLicense(LICENCE_KEY);
import {
	  METRIC_ACCURACY,
	  METRIC_NO_SHOW,
	  METRIC_WORKSTATION,
	  METRIC_EFFICIENCY
	} from "../../../constants/metrics";
	
import { METRIC_CONFIG } from "../../../constants/metric-config";

export default function WorksettingPerformanceDrawer({ entity }) {

	const [selectedMetric, setSelectedMetric] = useState('');
	
  return (
    <div style={container}>

      {/* 🔥 TITLE */}
      <div style={title}>
        {entity}
      </div>

      {/* 🔥 RINGS ROW */}
      <div style={ringsRow}>
	  	<AmChartRingIndicator
	      id="kpi_drawer_accuracy"
	      percentage={82}
	      width={120}
	      height={120}
		  label={METRIC_CONFIG[METRIC_ACCURACY].label}
		  color={METRIC_CONFIG[METRIC_ACCURACY].color}
		  metric={METRIC_ACCURACY}
	      selectedMetric={selectedMetric}
	    />
		<AmChartRingIndicator
	      id="kpi_drawer_noshow"
	      percentage={18}
	      width={120}
	      height={120}
		  label={METRIC_CONFIG[METRIC_NO_SHOW].label}
		  color={METRIC_CONFIG[METRIC_NO_SHOW].color}
		  metric={METRIC_NO_SHOW}
	      selectedMetric={selectedMetric}
	    />
		<AmChartRingIndicator
	      id="kpi_drawer_workstation"
	      percentage={64}
	      width={120}
	      height={120}
		  label={METRIC_CONFIG[METRIC_WORKSTATION].label}
		  color={METRIC_CONFIG[METRIC_WORKSTATION].color}
		  metric={METRIC_WORKSTATION}
	      selectedMetric={selectedMetric}
	    />
		<AmChartRingIndicator
	      id="kpi_drawer_efficiency"
	      percentage={71}
	      width={120}
	      height={120}
		  label={METRIC_CONFIG[METRIC_EFFICIENCY].label}
		  color={METRIC_CONFIG[METRIC_EFFICIENCY].color}
		  metric={METRIC_EFFICIENCY}
	      selectedMetric={selectedMetric}
	    />
		
      </div>
	  {KpiStrip()}
	  <div style={chartGrid}>
	  	<div style={chartGridColumn}>
			{ActivityHeatmap()}
			<BulletCharts/>
		</div>
		<div style={chartGridColumn}>
			<TopOffenders/>
			<span
			  onClick={() => alert(`Filter applied: ${o.name}`)}
			  style={{
			    fontSize: "12px",
			    color: "#60a5fa",
			    cursor: "pointer",
				borderTop: "1px solid rgba(255,255,255,0.05)",
				paddingTop: "8px"
			  }}
			  onMouseEnter={e => e.target.style.opacity = 0.7}
			  onMouseLeave={e => e.target.style.opacity = 1}
			>
			  Apply {entity} to filter→
			</span>
		</div>
	  </div>
	 
    </div>
  );
}


function KpiStrip() {
  return (
    <div style={kpiRow}>
      <Kpi label="Bookings" value="1,248" />
      <Kpi label="Walk-ins" value="312" />
      <Kpi label="No Shows" value="224" />
      <Kpi label="Worksettings" value="89" />
    </div>
  );
}

function Kpi({ label, value }) {
  return (
    <div
      style={kpi}
      onMouseEnter={e => {
        e.currentTarget.style.background = "rgba(255,255,255,0.06)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = "rgba(255,255,255,0.03)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={kpiValue}>{value}</div>
      <div style={kpiLabel}>{label}</div>
    </div>
  );
};

function ActivityHeatmap() {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    const chart = am4core.create(chartRef.current, am4charts.XYChart);

    chart.padding(10, 10, 10, 10);

    chart.data = generateHeatmapData();

    // ================= AXES =================

    const xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    xAxis.dataFields.category = "hour";
    xAxis.renderer.grid.template.disabled = true;
    xAxis.renderer.labels.template.fill = am4core.color("#aaa");
    xAxis.renderer.labels.template.fontSize = 10;
	xAxis.renderer.minGridDistance = 10;

    const yAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    yAxis.dataFields.category = "day";
    yAxis.renderer.inversed = true;
    yAxis.renderer.grid.template.disabled = true;
    yAxis.renderer.labels.template.fill = am4core.color("#aaa");
    yAxis.renderer.labels.template.fontSize = 10;
	yAxis.renderer.minGridDistance = 10;

    // ================= SERIES =================

	const series = chart.series.push(new am4charts.ColumnSeries());

	series.dataFields.categoryX = "hour";
	series.dataFields.categoryY = "day";
	series.dataFields.value = "value"; // ✅ IMPORTANT (not valueZ)

	series.columns.template.width = am4core.percent(100);
	series.columns.template.height = am4core.percent(100);
	series.columns.template.strokeWidth = 0;

	const base = "#009fc2";   // your METRIC_ACTIVITY-ish teal
	const dark = "#062b33";   // darker version
	const light = "#00d4ff";  // lighter pop
	
	series.heatRules.push({
	  property: "fill",
	  target: series.columns.template,
	  min: am4core.color(dark),
	  max: am4core.color(light)
	});

    // subtle rounding
    series.columns.template.cornerRadius = 2;

    // tooltip
    series.columns.template.tooltipText =
      "{day} {hour}:00\nUtilisation: {value}";

    // ================= INTERACTION =================

    chart.cursor = new am4charts.XYCursor();
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;

    return () => chart.dispose();
  }, []);

  return (
    <div style={heatmapContainer}>
      <div style={heatmapTitle}>Activity Pattern</div>
      <div ref={chartRef} style={{ width: "100%", height: 180 }} />
    </div>
  );
}


const kpiRow = {
  display: "flex",
  gap: "10px"
};

const kpi = {
  flex: 1,
  padding: "10px 12px",
  borderRadius: "10px",
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(255,255,255,0.06)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  transition: "all 0.2s ease",
  cursor: "default"
};

const kpiValue = {
  fontSize: "18px",
  fontWeight: "600",
  color: "#fff"
};

const kpiLabel = {
  fontSize: "11px",
  color: "#888",
  marginTop: "2px"
};


/* ================= STYLES ================= */

const container = {
  display: "flex",
  flexDirection: "column",
  gap: "20px"
};

const title = {
  fontSize: "16px",
  fontWeight: "600",
  color: "#e6e6e6"
};

const ringsRow = {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  padding:'15px'
};


const heatmapContainer = {
  marginTop: "16px",
  padding: "12px",
  borderRadius: "10px",
  background: "rgba(255,255,255,0.02)",
  border: "1px solid rgba(255,255,255,0.05)"
};

const heatmapTitle = {
  fontSize: "12px",
  color: "#aaa",
  marginBottom: "6px"
};


const chartGrid = {
	display:'flex',
	width:'100%',
	alignItems:'top',
	marginTop:'-10px'
};

const chartGridColumn = {
	display:'flex',
	width:'50%',
	flexDirection:'column',
	justifyContent:'space-between',
	alignItems:'center'
};


function generateHeatmapData() {
  const data = [];
  const days = ["Mon1", "Tue1", "Wed1", "Thu1", "Fri1", "Mon2", "Tue2", "Wed2", "Thu2", "Fri2"];

  for (let d = 0; d < days.length; d++) {
    for (let h = 8; h <= 17; h++) {

      // realistic usage curve
      let base =
        h < 10 ? 40 :
        h < 12 ? 70 :
        h < 14 ? 85 :
        h < 16 ? 65 :
        45;

      const noise = Math.random() * 20 - 10;

      data.push({
        day: days[d],
        hour: h,
        value: Math.max(10, Math.round(base + noise))
      });
    }
  }

  return data;
}




